const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const API_ENDPOINTS = {
  JOB_LINES: `${API_BASE_URL}/admin/job-lines`,
  PERSON_IN_CHARGE: `${API_BASE_URL}/admin/person-in-charge`,
  SONY_EMPLOYEES: `${API_BASE_URL}/admin/sony-employees`,
  HEADLINES: `${API_BASE_URL}/admin/headlines`,
  DEPARTMENTS: `${API_BASE_URL}/admin/departments`,
  BUDGET_CODES: `${API_BASE_URL}/admin/budget-codes`,
  TEMP_LABORS: `${API_BASE_URL}/admin/temp-labors`,
  WORK_TYPES: `${API_BASE_URL}/admin/work-types`,
  EFFORT_UPLOAD: `${API_BASE_URL}/admin/effort-upload`,
  MODEL_UPLOAD: `${API_BASE_URL}/admin/model-upload`,
  MODELS: `${API_BASE_URL}/admin/models`,
  USERS: `${API_BASE_URL}/users`,
  PROJECTS: `${API_BASE_URL}/projects`,
  AUTH: `${API_BASE_URL}/auth`,
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001'
};